import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { loadingAction } from 'store/globalState/global';
import Topics from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.topics,
    app: state.app,
    actualUser: state.session.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showLoading: bindActionCreators(loadingAction, dispatch),
  };
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Topics));



// WEBPACK FOOTER //
// ./src/components/Topics/container/index.js